(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProgMedication', ProgMedication);

    ProgMedication.$inject = ['$resource'];

    function ProgMedication ($resource) {
        var resourceUrl =  'api/prog-medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/prog-medications/filter',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                isArray: true
            }
        });
    }
})();
